import instance from './DefaultApi';

export default class CategoryService {
    ControllerName = 'Category';

    // get all category for ddl
    GetCategoryDDL() {
            return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetCategoryDDL`).then(res => res)
        }
        // get all sub category for ddl
    GetSubCategoryDDL(categoryId) {
            return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetSubCategoryDDL/${categoryId}`).then(res => res)
        }
        // get all subcategories
    GetSubCategories(tableRequest) {
            return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetSubCategories`, tableRequest).then(res => res)
        }
        // create new sub categgory 
    CreateUpdateSubCategory(subCategryData) {
            return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/CreateUpdateSubCategory`, subCategryData).then(res => res);
        }
        // delete sub category
    DeleteSubCategory(subCategoryId) {
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/DeleteSubCategory/${subCategoryId}`).then(res => res);
    }

    // get all categories
    GetCategories(tableRequest) {
            return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetCategories`, tableRequest).then(res => res)
        }
        // create new categgory 
    CreateUpdateCategory(subCategryData) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/CreateUpdateCategory`, subCategryData).then(res => res);
    }


}